import { Http } from "../../../support";
import ListItemHighlight from "../../../shared/support/ListItemHighlight";

const initialState = {
  busy: false,
  data: [],
  error: undefined,
  pagination: {
    limit: 25
  }
};

const highlight = (store, data) => {
  const { data: historial_compra } =  store.state.cuenta.historial_compra.list;

  const tool = new ListItemHighlight(historial_compra);

  store.setState((state) => {
    state.cuenta.historial_compra.list.data = tool.getNewList(data, true);
  });
}

const paginate = async (store, meta = {}) => {
  store.setState((state) => {
    state.cuenta.historial_compra.list.busy = true;
  });

  try {
    const params = {
      ...meta
    }

    const response = await Http.get('api/compras', { params });

    store.setState((state) => {
      state.cuenta.historial_compra.list.busy = false;
      state.cuenta.historial_compra.list.data = response.data;
      state.cuenta.historial_compra.list.pagination = {
        ...state.cuenta.historial_compra.list.pagination,
        ...response.meta.pagination,
      }
    });
  } catch (error) {
    store.setState((state) => {
      state.cuenta.historial_compra.list.error = error.data || error;
      state.cuenta.historial_compra.list.busy = false;
    });
  }
};

const resetError = (store) => state => {
  state.cuenta.historial_compra.list.error = undefined;
};

const reset = store => state => {
  state.cuenta.historial_compra.list = {
    ...initialState,
    pagination: {
      ...initialState.pagination
    }
  }
}

const actions = {
  highlight,
  paginate,
  resetError,
  reset
}

const HistorialCompraListStore = {
  state: () => ({
    ...initialState,
    pagination: {
      ...initialState.pagination
    }
  }),
  actions
}

export default HistorialCompraListStore;